// How long to keep the decrypted key "hot" in memory after unlock

export const INACTIVITY_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes of inactivity before eviction
export const DEVICE_KEY_TTL_MS = INACTIVITY_TIMEOUT_MS; // 5 minutes TTL for device key cache

// Device Key
export const DEVICE_KEY_SERVER = "com.tideprotocol.mfa/device-key";

// GBRK (known key list) - single-blob storage
export const GBRK_STORAGE_KEY = "known_gbrk_list_v1";
export const GBRK_EMPTY = Object.freeze({ v: 1, keys: [] });
